import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function AccountManagement(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      ...rest,
      "data-tidal": "TidalIllustration",
      "data-tidal-illustration": "AccountManagement",
      sx,
      viewBox,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M23.177 24.017a9.243 9.243 0 1 0 0-18.487 9.243 9.243 0 0 0 0 18.487Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M23 17h-4.502c-.378 0-.62.429-.434.775a6.793 6.793 0 0 0 1.871 2.189 5.05 5.05 0 0 0 6.13 0 6.792 6.792 0 0 0 1.87-2.189c.187-.346-.055-.775-.433-.775H23Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M38.302 39.142C37.781 31.183 31 24.857 22.757 24.857S7.733 31.183 7.211 39.142h31.091Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M33.75 30.146a3.604 3.604 0 1 0 0 7.208 3.604 3.604 0 0 0 0-7.208Zm0 5.447a1.842 1.842 0 1 1 0-3.685 1.842 1.842 0 0 1 0 3.685Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "m40.927 38.065-.812-.69a.441.441 0 0 1-.108-.532c.306-.62.519-1.28.63-1.962a.439.439 0 0 1 .398-.368l1.062-.087a.439.439 0 0 0 .402-.474l-.15-1.823a.44.44 0 0 0-.473-.402l-1.062.087a.441.441 0 0 1-.453-.301 6.932 6.932 0 0 0-.94-1.831.441.441 0 0 1 .02-.543l.689-.813a.44.44 0 0 0-.051-.62l-1.394-1.183a.44.44 0 0 0-.62.05l-.69.813a.441.441 0 0 1-.532.108 6.937 6.937 0 0 0-1.962-.63.44.44 0 0 1-.368-.398l-.087-1.062a.44.44 0 0 0-.474-.402l-1.823.149a.44.44 0 0 0-.402.474l.087 1.061a.441.441 0 0 1-.302.454c-.653.22-1.27.537-1.83.94a.44.44 0 0 1-.543-.02l-.813-.69a.44.44 0 0 0-.62.052l-1.183 1.394a.44.44 0 0 0 .05.62l.813.689a.441.441 0 0 1 .108.533 6.937 6.937 0 0 0-.63 1.962.439.439 0 0 1-.398.368l-1.062.087a.44.44 0 0 0-.402.474l.149 1.822a.44.44 0 0 0 .474.403l1.061-.087a.441.441 0 0 1 .454.301c.22.654.537 1.27.94 1.83a.44.44 0 0 1-.02.544l-.69.812a.44.44 0 0 0 .052.62l1.394 1.183a.44.44 0 0 0 .62-.05l.689-.812a.441.441 0 0 1 .533-.108c.619.306 1.28.519 1.962.63a.439.439 0 0 1 .368.398l.087 1.062a.44.44 0 0 0 .474.402l1.822-.15a.441.441 0 0 0 .403-.473l-.087-1.062a.441.441 0 0 1 .301-.453 6.93 6.93 0 0 0 1.83-.94.441.441 0 0 1 .544.02l.812.689a.438.438 0 0 0 .62-.051l1.183-1.394a.44.44 0 0 0-.05-.62Zm-4.686-2.2a3.267 3.267 0 1 1-4.982-4.229 3.267 3.267 0 0 1 4.982 4.228Z",
            fill: theme.vars.palette.primary.dark
          }
        )
      ]
    }
  );
}
AccountManagement.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "AccountManagement"
};
validateTidalLicense();
export {
  AccountManagement
};
//# sourceMappingURL=AccountManagement.js.map
